import React, { createContext, useContext, useState } from 'react';
import { useEvent } from '../../../../../../hooks/useEvent';

const StateContext = createContext();
const ActionsContext = createContext();
const HasSelectedRoomsContext = createContext();

export const useSelectedRooms = () => useContext(StateContext);

export const useHasSelectedRooms = () => useContext(HasSelectedRoomsContext);

export const useRoomsSelectionActions = () => useContext(ActionsContext);

export const useRoomsSelectionConfig = () => {
  const value = useSelectedRooms();
  const { onChange } = useRoomsSelectionActions();

  return { value, onChange };
};

export const RoomsSelectionProvider = ({ children }) => {
  const [selectedRoomIds, setSelectedRoomIds] = useState([]);

  const handleChange = useEvent(({ value }) => setSelectedRoomIds(value ?? []));

  const reset = useEvent(() => setSelectedRoomIds([]));

  const getSelectedIds = useEvent(() => selectedRoomIds);

  const actions = useState(() => ({
    onChange: handleChange,
    onReset: reset,
    getSelectedIds,
  }))[0];

  return (
    <StateContext.Provider value={selectedRoomIds}>
      <ActionsContext.Provider value={actions}>
        <HasSelectedRoomsContext.Provider value={selectedRoomIds.length > 1}>
          {children}
        </HasSelectedRoomsContext.Provider>
      </ActionsContext.Provider>
    </StateContext.Provider>
  );
};
